import { createElementSync, createElement, getNewElementId } from '../element/actions/elementActions';
import { getNewTransactionId } from '../utils/undoRedo/undoRedoTransactionManager';
import { ElementType } from '../../common/elements/elementTypes';

export const createPublicTemplate =
    ({ location, currentBoardId, creationSource, transactionId = getNewTransactionId() }) =>
    async (dispatch, getState) => {
        const { EXAMPLE_BOARD_DEFAULT_CONTENT, EMPTY_BOARD_DEFAULT_CONTENT } = await import(
            /* webpackChunkName: "public-template-boards-content" */ './publicTemplatesDefaultContent'
        );

        const exampleBoardId = dispatch(getNewElementId());
        const emptyBoardId = dispatch(getNewElementId());

        const boardId = dispatch(
            createElementSync({
                elementType: ElementType.BOARD_TYPE,
                location,
                transactionId,
                creationSource,
                content: {
                    title: 'New Public Template',
                    isPublicTemplate: true,
                    templateExampleLink: exampleBoardId,
                    templateLink: emptyBoardId,
                },
            }),
        );

        dispatch(
            createElement(
                {
                    elementType: ElementType.BOARD_TYPE,
                    location: {
                        parentId: boardId,
                        section: 'CANVAS',
                        position: {
                            x: 6,
                            y: 5,
                        },
                    },
                    content: {
                        ...EXAMPLE_BOARD_DEFAULT_CONTENT,
                        templateLink: emptyBoardId,
                    },
                    transactionId,
                    creationSource,
                },
                exampleBoardId,
            ),
        );

        dispatch(
            createElement(
                {
                    elementType: ElementType.BOARD_TYPE,
                    location: {
                        parentId: boardId,
                        section: 'CANVAS',
                        position: {
                            x: 18,
                            y: 5,
                        },
                    },
                    content: {
                        ...EMPTY_BOARD_DEFAULT_CONTENT,
                        templateExampleLink: exampleBoardId,
                    },
                    transactionId,
                    creationSource,
                },
                emptyBoardId,
            ),
        );
    };
